import { GraphColours, graphColours } from '@keplerco/core';

// Here we are removing the black and white colours from the graph
// colour list to avoid having black on a dark background, and
// white on a light background.
export const filteredColours: GraphColours[] = graphColours.filter(i => i !== 'grc_14' && i !== 'grc_13');
